/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import { Jumbotron, Grid, Row, Col } from 'react-bootstrap';
import Fade from "react-reveal/Fade";
import PropTypes from 'prop-types';

import ActionCreator from '../../../../action/ActionCreator';

import BaseComponent from '../../../../panther/components/base/BaseComponent';
import Button from '../../../../panther/components/atoms/Button/Button.js';

import styles from './MicrositeIntro.css';

class MicrositeIntro extends BaseComponent {
    constructor() {
        super();
    }

    changeView(view) {
        ActionCreator.viewChange(view);
    }

    render() {
        let introText = [];
        let buttons = [];

        buttons.push(this.renderExploreButton());

        if (this.props.text){
            introText.push(this.renderIntroText());
        }
        if (this.props.mapButton){
            buttons.push(this.renderMapButton());
        }



        return (
            <Jumbotron id="intro" className="text-center">
                <div className="microsite-intro-overlay"></div>
                <Grid className="microsite-intro-content">
                    <Row className="show-grid microsite-intro-title">
                        <Fade>
                            <Col xs={12} sm={12} md={10} mdOffset={1} lg={8} lgOffset={2}>
                                <h1>{this.props.title}</h1>
                            </Col>
                        </Fade>
                    </Row>
                    {introText}
                    <Row className="show-grid">
                        <Fade>
                            <Col xs={12} sm={12} md={10} mdOffset={1} lg={8} lgOffset={2}>
                                <img className="intro-logo" alt="Project main logo"
                                     src={require("../../../../resources/img/logo-pucs.png")}
                                />
                            </Col>
                        </Fade>
                    </Row>
                </Grid>
                <Grid className="microsite-intro-footer">
                    <Row className="show-grid microsite-intro-button">
                        <Fade>
                        <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2} lg={6} lgOffset={3}>
                            {buttons}
                        </Col>
                        </Fade>
                    </Row>
                </Grid>
            </Jumbotron>
        );
    }

    /**
     * @returns {XML}
     */
    renderIntroText(){
        return (
            <Row className="show-grid microsite-intro-text" key={this.props.text.substring(0,5)}>
                <Fade>
                <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2} lg={8} lgOffset={2}>
                    <p>{this.props.text}</p>
                </Col>
                </Fade>
            </Row>
        );
    }

    renderExploreButton(){
        return (
            <Button
                key="explore-button"
                primary
                inverse
                iconRight
                iconFa
                icon="fa-arrow-down"
                large
                alignCenter
                className="w16 introButton"
                onClick={this.changeView.bind(this, "about")}
            > Read more
            </Button>
        );
    }

    renderMapButton(){
        return (
            <Button
                key="render-button"
                primary
                iconRight
                iconFa
                icon="fa-arrow-right"
                large
                alignCenter
                className="w14 introButton"
                onClick={this.changeView.bind(this, "map")}
            >
                Show map
            </Button>
        );
    }
}

MicrositeIntro.propTypes = {
    text: PropTypes.string,
    mapButton: PropTypes.bool
};

export default MicrositeIntro;